import { AxiosInstance } from 'axios'
import { getLocaleLang } from '../utils/business/locale'
const X_LANG = 'X-Lang'
/**
 * 动态字体拦截器
 * @param axiosIns axios实例
 */
export function interceptAxiosWithLang(axiosIns: AxiosInstance) {
  const lang = getLocaleLang()
  axiosIns.interceptors.request.use((config) => {
    config.headers = {
      ...config.headers,
      [X_LANG]: lang,
    }
    return config
  })
}
